var $ = require('jquery');
var LazyLoad = require('lazyloader');
var PubSub = require('./pub-sub');
var PubSubMessageKeys = require('utils/pubSubMessageKeys');
var DomUtilities = require('utils/dom-utilities');

var mdlAttributesHandler =  {
	fetchMDLAttributes: function _fetchMDLAttributes(context) {
			var _self = this,
				requiredAttributes = context.$el.data('analytics-attributes');
			DomUtilities.checkValidMDLAttributes(requiredAttributes, _self.postMDLAttributes.bind(context));
	},

			/**
		* This function is used to post the attributes which need to be updated post tile load
		* @params {Object} Data Object which needs to be sent in ajax request
		*/
	postMDLAttributes: function _postMDLAttributes(postData) {
		var context = this;
		if (context.$el.data('url')) {
			context.makeAjaxCall({
				url: context.$el.data('url'),
				method: 'POST',
				data: JSON.stringify(postData)
			});
		}
	}
}
module.exports = mdlAttributesHandler; 